import { Fragment, useEffect, useState } from "react"
import { connect } from "react-redux";
import moment from 'moment';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Table
} from "reactstrap"
import VWModel from '../../components/vwModal/vwModal'
import {
  closeCreateZoneModal,
  closeUpdateZoneModal,
  getZonesList,
  openCreateZoneModal,
  openUpdateZoneModal,
  setZoneDetails
} from "../../store/zones/actions";
import Skeleton from '../../components/vwSkeleton/vwSkeleton'
import { Link } from "react-router-dom";
import AddZone from "./AddZone";
import EditZone from "./EditZone";
import { getPager } from "../../helper/common";
import VWPagination from "../../components/vwPagination/vwPagination";
import NoRecord from "../../components/NoRecords/noRecords";
import {
  ORGANIZATION_ADMIN,
  SUPER_ADMIN
} from "../../store/users/role.constants";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import "../FixedColumn.css";

const style = {
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },
};

const ZonesList = (props) => {

  const { zoneList, isCreateZoneModalOpen, isGetZonesPending, isUpdateZoneModalOpen, currentProfile, errorMessage } = props;
  const [pageSize, setPageSize] = useState(10);
  const [pager, setPager] = useState({ currentPage: 1 });

  const isAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0].roleKey === SUPER_ADMIN || currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN);

  const setPage = (page = 1) => {
    props.getZonesList(page, pageSize, sortDirection, sortOrder);
    setPager(prevPager => {
      const totalPages = Math.ceil(props.totalRecords / pageSize);
      const visiblePages = 5;
      const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
      const newPages = [];
      for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
        newPages.push(i);
      }
      return {
        ...prevPager,
        currentPage: page,
        totalPages,
        pages: newPages,
      };
    });
  };
  useEffect(() => {
    const currentUpdatePager = getPager(props.totalRecords, 1, pageSize);
    setPager(currentUpdatePager);
  }, [props.totalRecords, pageSize]);

  // useEffect(() => {
  //   const currentPageNo = pager && pager.currentPage;
  //   setPage(currentPageNo);
  // }, []);

  useEffect(() => {
    setPage();
  }, [pageSize])

  const handleClose = () => {
    const { closeCreateZoneModal } = props;
    closeCreateZoneModal();
  };

  const handleOpenCreateZone = () => {
    const { openCreateZoneModal } = props;
    openCreateZoneModal();
  };

  const handleUpdateClose = () => {
    const { closeUpdateZoneModal } = props;
    setZoneDetails(null);
    closeUpdateZoneModal();
  };

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortOrder === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder(column);
      setSortDirection('asc');
    }
  };
  useEffect(() => {
    if (sortOrder && sortDirection) {
      setPage();
    }
  }, [sortOrder, sortDirection])

  const handleOpenUpdateZone = (id) => {
    const { setZoneDetails, openUpdateZoneModal, zoneList } = props;
    const selected_zone = zoneList.find((zone) => {
      return zone.id === id;
    });
    setZoneDetails(selected_zone);
    openUpdateZoneModal();
  };

  return (
    <>
      <div className="page-content">
        <Card>
          <CardTitle className="p-2 mb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
            ZONES
            {(isAdmin) &&
              <Link
                type="button"
                className="mr-1 btn btn-primary btn-sm"
                onClick={handleOpenCreateZone}
              >
                <em className="fas fa-plus me-2"></em>Create Zone
              </Link>}
          </CardTitle>
        </Card>
        <Card>
          <CardBody>
            {errorMessage && (
              <Message
                type="danger"
                defaultMessage={errorMessage}
                baseClassName="alert"
              />
            )}
            <div style={{ maxHeight: "500px", overflowX: "auto" }}>
              <Table className="table table-hover table-nowrap w-100" size='sm' style={style.table}>
                <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "10" }}>
                  <tr>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('zoneName')}>
                      NAME
                      {sortOrder === 'zoneName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('isActive')}>
                      STATUS
                      {sortOrder === 'isActive' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdBy')}>
                      CREATED BY
                      {sortOrder === 'createdBy' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdDateTime')}>
                      CREATED ON
                      {sortOrder === 'createdDateTime' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('updatedBy')}>
                      UPDATED BY
                      {sortOrder === 'updatedBy' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('updatedDateTime')}>
                      UPDATED ON
                      {sortOrder === 'updatedDateTime' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    {(isAdmin) && <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}>
                      ACTION
                    </th>}
                  </tr>
                </thead>
                <tbody>
                  {(zoneList && zoneList.length > 0) && !isGetZonesPending ?
                    zoneList.map((data, index) => (
                      <tr key={index}>
                        <td>{data.zoneName || "NA"}</td>
                        <td>
                          {data.isActive ? (
                            <Badge color="success">Active</Badge>
                          ) : (
                            <Badge color="danger">Inactive</Badge>
                          )}
                        </td>
                        <td>{data.createdBy || "NA"}</td>
                        <td>{data.createdDateTime ? moment(data.createdDateTime).format("DD MMM YYYY") : "NA"}</td>
                        <td>{data.updatedBy || "NA"}</td>
                        <td>{data.updatedDateTime ? moment(data.updatedDateTime).format("DD MMM YYYY") : "NA"}</td>
                        {(isAdmin) && <td className="text-center sticky-column bg-white">
                          <Button
                            color='light'
                            size='sm'
                            onClick={() => handleOpenUpdateZone(data.id)}
                          >
                            <em className="fa fa-edit"></em>
                          </Button>
                        </td>}
                      </tr>
                    ))
                    : isGetZonesPending ? (
                      <tr>
                        <td colSpan={9} align="center" className="p-4">
                          <Skeleton type="body" />
                          {/* <Spinner color="primary">Loading</Spinner> */}
                          {/* <VWSpinner /> */}
                          <VWLoading />
                        </td>
                      </tr>
                    ) :
                      <tr>
                        <td colSpan={9}>
                          <NoRecord />
                        </td>
                      </tr>
                  }
                </tbody>
              </Table>
            </div>
          </CardBody>
          <CardFooter>
            {props.zoneList.length > 0 ?
              <VWPagination
                pager={pager}
                setPage={setPage}
                totalRecords={props.totalRecords}
                pageSize={pageSize}
                setPageSize={setPageSize}
              /> : null
            }
          </CardFooter>
          <VWModel
            header="ADD ZONE"
            isOpen={isCreateZoneModalOpen}
            handleClose={handleClose}
          >
            <AddZone handleClose={handleClose} />
          </VWModel>
          <VWModel
            header="EDIT ZONE"
            isOpen={isUpdateZoneModalOpen}
            handleClose={handleUpdateClose}
          >
            <EditZone handleClose={handleUpdateClose} />
          </VWModel>

        </Card >
      </div >
    </>
  )
}
const mapStateToProps = (state) => ({
  isCreateZoneModalOpen: state.zones.isCreateZoneModalOpen,
  isUpdateZoneModalOpen: state.zones.isUpdateZoneModalOpen,
  zoneList: state.zones.zones,
  errorMessage: state.zones.zoneListError,
  totalRecords: state.zones.totalRecords,
  isGetZonesPending: state.zones.isGetZonesPending,
  currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
  openCreateZoneModal: () => dispatch(openCreateZoneModal()),
  closeCreateZoneModal: () => dispatch(closeCreateZoneModal()),
  openUpdateZoneModal: () => dispatch(openUpdateZoneModal()),
  closeUpdateZoneModal: () => dispatch(closeUpdateZoneModal()),
  getZonesList: (page, pageSize, sortDirection, sortOrder) => dispatch(getZonesList(page, pageSize, sortDirection, sortOrder)),
  setZoneDetails: (data) => dispatch(setZoneDetails(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZonesList)